export function verificaRota(statusliberacao) {

    if (statusliberacao === undefined) {
        return false;
    }
    return (statusliberacao == 3 || statusliberacao == 10) ? true : false;
}

export function verificaRotaNaoExiste() {
    var url = window.location.href;
    return (url.indexOf('null') !== -1) ? true : false;
}